/**
 * Personalisation cart sync.
 * The personalisation add-on (product handle "personalisation-add-on") is sold
 * as its own cart line, linked to its parent by the "For" line item property
 * (parent product title). After any cart change:
 *  - add-on lines whose parent product left the cart are removed;
 *  - per parent, the total quantity of each add-on TYPE (variant) is capped at
 *    the parent's quantity, trimming excess lines. Different add-on types are
 *    not summed together — one unit can carry initials AND a name — and having
 *    fewer add-ons than parent units is fine (personalise only some units).
 *
 * Loaded from layout/theme.liquid. See snippets/personalisation-options.liquid.
 */
(() => {
  const ADDON_HANDLE = 'personalisation-add-on';
  let reconciling = false;
  let queued = false;

  async function reconcile() {
    if (reconciling) { queued = true; return; }
    reconciling = true;
    try {
      const cart = await (await fetch('/cart.js')).json();
      const parentQty = {};
      cart.items.forEach((i) => {
        if (i.handle === ADDON_HANDLE) return;
        parentQty[i.product_title] = (parentQty[i.product_title] || 0) + i.quantity;
      });
      const updates = {};
      const groups = new Map();
      cart.items.forEach((i) => {
        if (i.handle !== ADDON_HANDLE) return;
        const parent = i.properties && i.properties.For;
        if (!parent || !(parent in parentQty)) {
          if (parent) updates[i.key] = 0;
          return;
        }
        const gk = parent + '::' + i.variant_id;
        if (!groups.has(gk)) groups.set(gk, { allowed: parentQty[parent], lines: [] });
        groups.get(gk).lines.push(i);
      });
      groups.forEach((g) => {
        let remaining = g.allowed;
        g.lines.forEach((line) => {
          const keep = Math.max(0, Math.min(line.quantity, remaining));
          remaining -= keep;
          if (keep < line.quantity) updates[line.key] = keep;
        });
      });
      if (Object.keys(updates).length) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates })
        });
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.refresh === 'function') drawer.refresh(false);
        const cartItems = document.querySelector('cart-items');
        if (cartItems && typeof cartItems.refresh === 'function') cartItems.refresh();
      }
    } catch (e) { /* never break the cart over sync */ } finally {
      reconciling = false;
      if (queued) { queued = false; reconcile(); }
    }
  }

  const origFetch = window.fetch;
  window.fetch = function patchedFetch(input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const result = origFetch.apply(this, arguments);
    if (/\/cart\/(change|update)(\.js)?([/?]|$)/.test(url)) {
      result.then((res) => { if (res.ok && !reconciling) setTimeout(reconcile, 150); }).catch(() => {});
    }
    return result;
  };
})();
